import React from 'react'
import { Users, UserPlus } from 'lucide-react'
import { colors } from '../../styles/tokens'
import { styles } from '../../styles/newQuotation.styles'

/**
 * Modal de seleção do tipo de cliente
 * 
 * Responsabilidade: Perguntar se cliente é novo ou da base
 */
export default function ClientTypeModal({
    destination,
    onSelect,
    onBack,
    loading
}) {
    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent('500px')}>
                <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    color: colors.primary,
                    marginBottom: '0.5rem',
                    textAlign: 'center'
                }}>
                    Tipo de cliente
                </h3>

                <p style={{
                    fontSize: '0.875rem',
                    color: colors.text.secondary,
                    marginBottom: '0.5rem',
                    textAlign: 'center'
                }}>
                    Destino detectado: <strong>{destination}</strong>
                </p>

                <p style={{
                    fontSize: '0.875rem',
                    color: colors.text.secondary,
                    marginBottom: '1.5rem',
                    textAlign: 'center'
                }}>
                    Este cliente já é da sua base?
                </p>

                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
                    <button
                        onClick={() => onSelect(true)}
                        disabled={loading}
                        style={styles.clientTypeButton}
                        onMouseOver={(e) => { e.currentTarget.style.borderColor = colors.accent }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = colors.border }}
                    >
                        <Users size={32} color={colors.accent} />
                        <span style={{ fontSize: '1rem', fontWeight: 600, color: colors.text.primary }}>
                            Sim
                        </span>
                        <span style={{ fontSize: '0.75rem', color: colors.text.secondary, textAlign: 'center' }}>
                            Cliente da base, pula o briefing
                        </span>
                    </button>

                    <button
                        onClick={() => onSelect(false)}
                        disabled={loading}
                        style={styles.clientTypeButton}
                        onMouseOver={(e) => { e.currentTarget.style.borderColor = colors.primary }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = colors.border }}
                    >
                        <UserPlus size={32} color={colors.primary} />
                        <span style={{ fontSize: '1rem', fontWeight: 600, color: colors.text.primary }}>
                            Não
                        </span>
                        <span style={{ fontSize: '0.75rem', color: colors.text.secondary, textAlign: 'center' }}>
                            Cliente novo, mostra storytelling completo
                        </span>
                    </button>
                </div>

                <button
                    onClick={onBack}
                    disabled={loading}
                    style={{
                        ...styles.buttonOutline,
                        width: '100%',
                        textAlign: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {loading ? '⏳ Processando...' : 'Voltar'}
                </button>
            </div>
        </div>
    )
}